import { useRetrieveCouponQuery, useDeleteCouponPassMutation, useDeleteCouponMutation, useRetrieveCouponStatisticsQuery } from 'services/coupons';
import { Coupon } from '../../../../ui/data-display/Passes/coupon';
import { createTemplateDetails } from 'components/reusable/template';


export const CouponDetails = createTemplateDetails({
  TemplateRenderer: Coupon,
  retrieveHook: useRetrieveCouponQuery,
  retrieveStatisticsHook: useRetrieveCouponStatisticsQuery,
  deletePassHook: useDeleteCouponPassMutation,
  deleteTemplateHook: useDeleteCouponMutation,
  baseUrl: "/coupons/",
  i18nNamespace: "coupon",
})